module.exports = __webpack_public_path__ + "static/media/6.a3da9391.JPG";